import { fork } from 'redux-saga/effects';
import watchUserAction from './watcher';

export default function* startForman() {
    yield fork(watchUserAction);
}